module.exports = __webpack_public_path__ + "static/media/logo-letras-negro-medium.d87abd58.png";